import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import EventsActions from 'app/actions/EventsActions';
import { selectActiveFilters } from 'app/selectors/events/EventsSearchSelector';

const EventsSearchPageContainer = loadable(() =>
  import('app/components/events/EventsSearchPage/EventsSearchPageContainer')
);

export function EventsSearchPageRoute() {
  return <EventsSearchPageContainer />;
}

function getRouteData({ dispatch, state, query }) {
  const activeFilters = selectActiveFilters(state);
  if (activeFilters.isEmpty()) {
    return [dispatch(EventsActions.searchEvents(query)), dispatch(EventsActions.getCalloutFeaturedEvent())];
  }
  return [dispatch(EventsActions.searchEvents(query))];
}

export default connectRoute(EventsSearchPageRoute, {
  getRouteData,
  debounceOptions: {
    wait: 100 // milliseconds
  }
});
